import React from 'react'
import { Link } from 'gatsby'
import aboutImage from '../../assets/images/about/about-img5.png'
import starIcon from '../../assets/images/star-icon.png'
import icon4 from '../../assets/images/icons/icon4.png'
import icon5 from '../../assets/images/icons/icon5.png'
import icon6 from '../../assets/images/icons/icon6.png'
import icon7 from '../../assets/images/icons/icon7.png'
import shape1 from '../../assets/images/shape/circle-shape1.png'
import scrollTo from 'gatsby-plugin-smoothscroll';

const AboutUsContent = () => {
    return (
        <section className="about-area ptb-100">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            <img src={aboutImage} alt="about zaavia" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <div className="content">
                                <span className="sub-title">
                                    <img src={starIcon} alt="about" />
                                    About Us
                                </span>
                                <h2>Building Software That Solves Real Problems– Zaavia!</h2>
                                <p>
                                    For more than a decade, Zaavia has been helping organizations replace slow, manual processes with software that makes everyday work SIMPLER, FASTER, and more RELIABLE.
                                </p>
                                <p>
                                    Our journey began in 2012 in healthcare, where accuracy is non-negotiable. We developed DIGITAL SOLUTIONS that support hospitals, laboratories, and blood banks in delivering safer and more efficient patient care. Today, our systems are being used by TOP HEALTHCARE INSTITUTIONS across PAKISTAN and the MIDDLE EAST.
                                </p>
                                <p>
                                    That same practical approach now extends beyond healthcare. We build CUSTOM SOFTWARE, BUSINESS APPLICATIONS and AI-POWERED AUTOMATION that help organizations reduce repetitive work, improve accuracy, and give teams more time to focus on innovation and strategy making.
                                </p>
                                <p>
                                    At Zaavia, we don't build software for the sake of technology. We build systems that solve real operational challenges, fit naturally into the way your business works, and continue to grow with you.
                                </p>

                                <ul className="features-list about-stats-list">
                                    <li>
                                        <img src={icon4} alt="years" />
                                        <h3>12+ Years</h3>
                                        <p>Building Software That Matters</p>
                                    </li>
                                    <li>
                                        <img src={icon5} alt="engineers" />
                                        <h3>25+</h3>
                                        <p>Software Engineers & Specialists</p>
                                    </li>
                                    <li>
                                        <img src={icon6} alt="trusted" />
                                        <h3>Trusted</h3>
                                        <p>by Healthcare & Businesses globally</p>
                                    </li>
                                    <li>
                                        <img src={icon7} alt="expertise" />
                                        <h3>Expertise</h3>
                                        <p>Healthcare, AI & Enterprise Software</p>
                                    </li>
                                </ul>

                                <p>If you have a project in mind, our experts will guide you through the steps.</p>

                                <div className="about-cta-btns">
                                    <button type="button" onClick={() => scrollTo('#history')} className="default-btn">
                                        <i className="flaticon-right"></i>
                                        History
                                        <span></span>
                                    </button>
                                    <Link to="/demo" className="default-btn">
                                        <i className="flaticon-right"></i>
                                        Let's talk!
                                        <span></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="circle-shape1">
                <img src={shape1} alt="shape" />
            </div>
        </section>
    )
}

export default AboutUsContent;